import type { Session } from '@change-corgi/core/session';

export function isGuest(session: Session) {
	return session.loginState === 'GUEST';
}
